module.exports = __webpack_public_path__ + "static/media/tarjeta.342c1b93.svg";